export default __webpack_public_path__ + "static/media/why-to-use-git.c943b25b.png";